module.exports = __webpack_public_path__ + "media/images/company-094fead1e87a6b94900b606b84e9d8c6.png";